<template>
    <div class="success-form">
        <v-container>
            <div class="page-content">
                <div class="page-content-head">
                    <h1 class="title-page">Обратная связь</h1>
                    <div class="indicator-3">
                        <span class="green"></span>
                        <span class="yellow"></span>
                        <span class="redhead"></span>
                    </div>
                </div>
                <div class="page-content-body">
                    <h3>Ваше обращение №{{ feedbackId}} успешно отправлено!</h3>
                    <p>
                        <router-link to="/">Перейти на главную</router-link>
                        <router-link to="/feedback">Написать ещё одно обращение</router-link>
                    </p>
                </div>
            </div>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: "SuccessFeedback",
        data: () => ({
            feedbackId: null
        }),
        created() {
            this.feedbackId = this.$router.currentRoute.params.id
        },
    }
</script>